




export const spartaContainerSelector = '[data-sparta-wrapper]';





export const spartaWidgetContainerString = 'data-sparta-widget';





export const spartaWidgetContainerSelector = `[${spartaWidgetContainerString}]`;





export const utilityLoadingClass = 'sparta-media-query-utility-loading';





export const spartaWidgetResizeDebounceDelay = 200;





export const mediaQueryViewportString = 'viewport';





export const mediaQueryOrientationString = 'orientation';





export const mediaQueryResolutionString = 'resolution';





export const mediaQueryUpString = 'up';





export const mediaQueryOnlyString = 'only';





export const spartaStoreNamespace = 'currentMQ';





export const spartaStoreMediaQueriesKey = 'mediaQueries';


















export const smallMinWidth = 1;





export const mediumMinWidth = 768;





export const largeMinWidth = 1025;





export const largeCenteredMinWidth = 1316;





export const xlargeMinWidth = 1441;





export const xxlargeMinWidth = 1921;





export const smallViewportName = 'small';





export const smallViewportString = smallViewportName;





export const mediumViewportName = 'medium';





export const mediumViewportString = mediumViewportName;





export const largeViewportName = 'large';





export const largeViewportString = largeViewportName;





export const xlargeViewportName = 'xlarge';





export const xlargeViewportString = xlargeViewportName;





export const xxlargeViewportName = 'xxlarge';





export const xxlargeViewportString = xxlargeViewportName;





export const largeCenteredViewportName = 'largeCentered';





export const landscapeOrientationName = 'landscape';





export const portraitOrientationName = 'portrait';





export const defaultResolutionName = 'standard';





export const retinaResolutionName = 'retina';





export const smallMediaQueryString = `only screen and (min-width: ${smallMinWidth}px)`;





export const mediumMediaQueryString = `only screen and (min-width: ${mediumMinWidth}px)`;





export const largeMediaQueryString = `only screen and (min-width: ${largeMinWidth}px)`;





export const largeCenteredMediaQueryString = `only screen and (min-width: ${largeCenteredMinWidth}px)`;





export const xlargeMediaQueryString = `only screen and (min-width: ${xlargeMinWidth}px)`;





export const xxlargeMediaQueryString = `only screen and (min-width: ${xxlargeMinWidth}px)`;





export const portraitMediaQueryString = `only screen and (orientation: ${portraitOrientationName})`;





export const landscapeMediaQueryString = `only screen and (orientation: ${landscapeOrientationName})`;





export const defaultResolutionMediaQueryString = `not screen and (min-device-pixel-ratio: 2), not screen and (min-resolution: 192dpi), not screen and (min-resolution: 2dppx)`;





export const retinaResolutionMediaQueryString = `only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)`;





export const viewportNames = {
  [smallViewportName]: smallViewportString,
  [mediumViewportName]: mediumViewportString,
  [largeViewportName]: largeViewportString,
  [largeCenteredViewportName]: largeCenteredViewportName,
  [xlargeViewportName]: xlargeViewportString,
  [xxlargeViewportName]: xxlargeViewportString,
};
